import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postMobile1, postMobile2 } from "../../common/redux/MasterLayoutCRUD";
import { fishingSlice } from "./FishingSlice";

const { actions } = fishingSlice;

export const getFishingGameList = (queryParams) => (dispatch) => {
  const controller = new AbortController();
  const signal = controller.signal;

  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMobile2(queryParams, signal) // Pass signal to the API call
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.fishingGameListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchFishingGameList");
      }
    })
    .catch((error) => {
      if (error.name !== "AbortError") {
        // Check if the error is due to aborting
        dispatch(
          actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
        );
        throw error;
      }
    });
};

export const clearPromotion = () => (dispatch) => {
  dispatch(actions.clearPromotion());
};

export const clearFishingGameList = () => (dispatch) => {
  dispatch(actions.clearFishingGameList());
};

export const playGame = (queryParams) => (dispatch) => {
  const controller = new AbortController(); // Create an instance of AbortController
  const signal = controller.signal; // Get the signal from the controller

  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postMobile1(queryParams, signal) // Pass signal to the API call
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.playCompanyGame({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: companyPlayGame");
      }
    })
    .catch((error) => {
      if (error.name !== "AbortError") {
        // Check if the error is due to aborting
        dispatch(
          actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
        );
        throw error;
      }
    });
};
